export enum AsyncActionType {
  FETCH_ROLES = 'ROLES/FETCH_ROLES',
  CREATE_ROLE = 'ROLES/CREATE_ROLE',
  UPDATE_ROLE = 'ROLES/UPDATE_ROLE',
  DELETE_ROLE = 'ROLES/DELETE_ROLE',
}
